import React from 'react';

export const Header = ({
  theme,
  onToggleTheme,
  onMenuClick,
  onSearchClick,
  isSearchActive
}) => {
  return (
    <div className="header">
      <h1>Kalamly</h1>
      <div style={{ display: 'flex', gap: '0.5rem' }}>
        <button
          className={`theme-btn ${isSearchActive ? 'active' : ''}`}
          onClick={onSearchClick}
          aria-label="Search cards"
        >
          🔍
        </button>
        <button className="theme-btn" onClick={onToggleTheme} aria-label="Toggle theme">
          {theme === 'light' ? '🌙' : '☀️'}
        </button>
        <button className="theme-btn" onClick={onMenuClick} aria-label="Menu">
          ⋯
        </button>
      </div>
    </div>
  );
};
